// Demander la permission pour les notifications
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('Ce navigateur ne supporte pas les notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

// Envoyer une notification locale
export const sendLocalNotification = (title, options = {}) => {
  if (Notification.permission === 'granted') {
    const notification = new Notification(title, {
      icon: '/icon-192.png',
      badge: '/icon-192.png',
      vibrate: [200, 100, 200],
      ...options
    });

    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    return notification;
  }
};

// Notifications prédéfinies
export const notifyNewClient = (clientName) => {
  sendLocalNotification('Nouveau client', {
    body: `${clientName} vient de s'inscrire !`,
    tag: 'new-client',
    requireInteraction: false
  });
};

export const notifyPaymentReceived = (clientName, amount) => {
  sendLocalNotification('Paiement reçu', {
    body: `${clientName} a payé ${amount}€`,
    tag: 'payment',
    requireInteraction: false
  });
};

export const notifyClientSigned = (clientName) => {
  sendLocalNotification('Contrat signé', {
    body: `${clientName} a signé le contrat`,
    tag: 'signature',
    requireInteraction: false
  });
};

export const notifyCommissionEarned = (amount) => {
  sendLocalNotification('Commission gagnée', {
    body: `Vous avez gagné ${amount}€ de commission`,
    tag: 'commission',
    requireInteraction: true
  });
};

// Vérifier si les notifications sont supportées
export const areNotificationsSupported = () => {
  return 'Notification' in window;
};

// Obtenir le statut de permission
export const getNotificationPermission = () => {
  if (!areNotificationsSupported()) {
    return 'unsupported';
  }
  return Notification.permission;
};
